module.exports = __webpack_public_path__ + "media/bgm.f3e192a1.mp3";